

import React from 'react';

import { DashboardLayout, GeneralTable } from "components";

import { func_validation, getTotalCountFromHeader } from 'functions';
import { generalInvoicesColumns } from './generalInvoicesColumns';

import 'assets/scss/distributorPortal/modules/invoices/generalInvoices.scss';



export default function GeneralInvoicesPresentation(props) {
    const { 
        getGeneralInvoices_requesting, getGeneralInvoices_status,
        generalInvoiceList, generalInvoiceListHeaders
    } = props;

    return (
        <div className={"distributorPortal-generalInvoices"}>
            <DashboardLayout
                headerTitle={"Invoices"}

                bodyClassName={"distributorPortal-generalInvoices-body"}
                body={(
                    <GeneralTable
                        className={"distributorPortal-generalInvoices-table"}
                        columns={generalInvoicesColumns.getColumns()}
                        data={generalInvoiceList}

                        getTableData={props.getGeneralInvoices}

                        outerTableHeader={(selectedRows) => {
                            return (
                                <div className={"distributorPortal-generalInvoices-table-header "}>
                                    <div className={"distributorPortal-generalInvoices-tableHeader-title tableHeaderTitle "}>
                                        List
                                    </div>
                                </div>
                            );
                        }}
                        
                        isTableDataLoading={getGeneralInvoices_requesting}

                        isUsingPagination
                        totalRecords={getTotalCountFromHeader(generalInvoiceListHeaders)}

                        isColumnResizeable
                        isTableOddRowsDarken
                    />
                )}
            />
        </div>
    );
}